import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import useFieldData from 'components/forms/hooks/useFieldData';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/cod/fields';
import {RequiresSignatureAbortButton} from 'components/forms/sections';
import {bootstrapOldForm} from 'components/forms/AutoSection';

const Signature = props => {
    const {schema, initialValues} = bootstrapOldForm('Signature', fields);
    const [signed, setSigned] = useFieldData('document_signed');
    const [userSigned, setUserSigned] = useFieldData('document_signed_user');

    const showWarning =
        signed === false ||
        signed === 'false' ||
        userSigned === false ||
        userSigned === 'false';

    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6' align='left'>
                Signature
            </Typography>
            <AutoField
                field={fields['document_signed']}
                name='document_signed'
                onChange={e => setSigned(e.target.value === 'true')}
            />
            {(signed === true || signed === 'true') && (
                <AutoField
                    field={fields['date_document_signed']}
                    name='date_document_signed'
                />
            )}
            <AutoField
                field={fields['document_signed_user']}
                name='document_signed_user'
                onChange={e => setUserSigned(e.target.value === 'true')}
            />
            {showWarning && <RequiresSignatureAbortButton />}
            {props.children}
        </Section>
    );
};

export default Signature;
